import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/layouts/Root';
import { useSelector } from 'react-redux';
import ApperIcon from '@/components/ApperIcon';

function Signup() {
  const { isInitialized } = useAuth();
  const { user } = useSelector(state => state.user);
  const navigate = useNavigate();

  const profileSlug = "|Hi4GjlwMoKSYakTcdzBO6XHt+bZj+GCNRWgWYZa3Jik=";

  useEffect(() => {
    if (isInitialized) {
      const { ApperUI } = window.ApperSDK;
      if (!user) {
        ApperUI.showSignup("#authentication", { profileSlug });
      } else {
        const searchParams = new URLSearchParams(window.location.search);
        const redirectPath = searchParams.get('redirect');
        navigate(redirectPath ? redirectPath : "/");
      }
    }
  }, [isInitialized, user, navigate]);

return (
    <div className="flex min-h-screen items-center justify-center bg-background-primary">
      <div className="w-full max-w-md space-y-8 p-8 glass-card rounded-card">
        <div className="flex flex-col gap-4 items-center justify-center">
          {/* PS Logo - colorful brand mark */}
          <div className="relative">
            <img
              src="/ps-logo.svg"
              alt="PS Logo"
              className="w-24 h-24 shrink-0"
              style={{
                minWidth: '96px',
                filter: 'drop-shadow(0 0 20px rgba(255, 140, 0, 0.45)) drop-shadow(0 8px 32px rgba(124,58,237,0.4))',
                borderRadius: '20px'
              }}
            />
          </div>
          <div className="flex flex-col gap-1.5 items-center justify-center">
            <div
              className="text-center font-display font-black text-white uppercase"
              style={{ fontSize: '1.3rem', letterSpacing: '0.2em', textShadow: '0 2px 12px rgba(124,58,237,0.5)' }}
            >
              PUBBLICITASOVERATO
            </div>
            <div
              className="text-center font-medium uppercase text-primary-400"
              style={{ fontSize: '0.7rem', letterSpacing: '0.18em' }}
            >
              Crea il tuo account
            </div>
          </div>
        </div>
        <div id="authentication" />
        <div className="text-center mt-4">
          <p className="text-sm text-gray-400">
            Hai già un account?{' '}
            <Link to="/login" className="font-medium text-primary hover:text-primary-400">
              Accedi
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;